import React from 'react';
import ApiBidPeriod from '../../code/api/ApiBidPeriod';
import BidPeriod from '../../code/models/BidPeriod';
import ApiIETrips from '../../code/api/ApiIETrips';
import BidPeriodFileImportRequestInfo from '../../code/models/BidPeriodFileImportRequestInfo';
import '../../css/adminbidpackagesietrips.css';

interface IAdminBidPackagesIETrips { }

export default function AdminBidPackagesIETrips({ }: IAdminBidPackagesIETrips) {
    const [bidPeriod, setBidPeriod] = React.useState<BidPeriod | undefined | null>(null);
    const [lastRequest, setLastRequest] = React.useState<BidPeriodFileImportRequestInfo | undefined | null>(null);

    React.useEffect(() => {
        loadHistory();
    }, []);

    function loadHistory() {
        ApiIETrips.getLastRequest().then(req => {
            setLastRequest(req);
        });

        ApiBidPeriod.getCurrentBidPeriod().then(bp => {
            setBidPeriod(bp);
        });
    }

    function handleBuildClick() {
        ApiIETrips.queueServiceRequest().then(req => {
            setLastRequest(req);
        });
    }

    function getStatusInfo() {
        return (
            <React.Fragment>
                <div>
                    <span className="tripchange-label">Last Import Date:</span>
                    {(!lastRequest) && <span className="tripchange-data">None for this bid period.</span>}
                    {!!lastRequest && <span className="tripchange-data">{new Date(lastRequest.statusDate).toLocaleString()}</span>}
                </div>
                <div>
                    <span className="tripchange-label">Status:</span>
                    {(!lastRequest) && <span className="tripchange-data">None for this bid period.</span>}
                    {!!lastRequest && <span className="tripchange-data">{lastRequest.status}</span>}
                </div>
                <div>
                    <span className="creditrange-label">Last Import Message:</span>
                    {!lastRequest && <span className="creditrange-data">N/A</span>}
                    {!!lastRequest && <span className="creditrange-data">{lastRequest.statusMessage}</span>}
                </div>
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <div className="tripchange-form">
                <div className="tripchange-div">
                    <span className="tripchange-title">Build IE Trips</span>
                    {!!bidPeriod && <span className="tripchange-label">Bid Period: {bidPeriod.month}</span>}
                </div>
                <div className="tripchange-div">
                    {getStatusInfo()}
                </div>
                <br />
                <div className="tripchange-div">
                    <span>&nbsp;&nbsp;</span><button onClick={handleBuildClick} className="btn btn-primary btn-md">Build IE Trips</button>
                </div>
            </div>
        </React.Fragment >
    )
}

